import { ImageComponent } from 'presentation/components/ImageComponent';

interface props {
    imageURLs: string[];
}

export const ImageRow = ({ imageURLs }: props) => {
    return (
        <section className="center-inside" style={{ marginTop: 32, background: '#ffffff' }}>
            <ImageComponent
                parentClassName="h-164 full-width"
                className="image-inside min-h-[335px]"
                src={imageURLs[0]}
            />
        </section>
    );
};
